import { render, staticRenderFns } from "./ColorList.vue?vue&type=template&id=c534f8c6&scoped=true&"
import script from "./ColorList.vue?vue&type=script&lang=js&"
export * from "./ColorList.vue?vue&type=script&lang=js&"
import style0 from "./ColorList.vue?vue&type=style&index=0&id=c534f8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c534f8c6",
  null
  
)

export default component.exports